import Common from '../../Common';
import { CompanyIntegration } from './Integration';
import Field, { CompanyAdSyncField } from './adsync/Field';
import Log from './adsync/Log';
import UserField from './adsync/UserField';
import UserSettingsTemplate from './adsync/UserSettingsTemplate';

interface Body {
	provider_settings: string
	user_sync_enabled: number
	new_users_only: number
	paused: number
	default_user_settings_template_template_id?: id
	delete_user_after_days: number
	send_welcome_mail: string
	send_welcome_mail_admin_mail: string
	error_notification_level: AdSyncWarningLevels
	error_notification_mail: string
	default_callerid_pbx_did_id: id
}

export interface CompanyAdSync {
	id: id
	pbx_company_id: id
	added_utc: string
	provider_name: string
	paused: "1" | "0"
	provider_settings?: string | null
	fields_hash: string
	user_sync_enabled: "1" | "0"
	new_users_only: "1" | "0"
	integration_id: id
	default_user_settings_template_template_id: id | null
	current_sync_id: string | null
	current_sync_start_utc: string | null
	delete_user_after_days: "1" | "0"
	send_welcome_mail: "1" | "0"
	send_welcome_mail_admin_mail: string | null
	error_notification_level: string
	error_notification_mail: string | null
	default_callerid_pbx_did_id: id | null
	integration: CompanyIntegration
	fields: CompanyAdSyncField[]
	user_fields: AdSyncUserField[]
}

export type CompanyAdSyncBrowse = Omit<CompanyAdSync, 'fields' | 'user_fields'>

const AdSync = class extends Common {
	field: InstanceType<typeof Field>;
	log: InstanceType<typeof Log>;
	userField: InstanceType<typeof UserField>;
	userSettingsTemplate: InstanceType<typeof UserSettingsTemplate>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.field = new Field(headers);
		this.log = new Log(headers);
		this.userField = new UserField(headers);
		this.userSettingsTemplate = new UserSettingsTemplate(headers);
	}

	read = (companyId: id, id: id): CustomResponse<CompanyAdSync> =>
		this.get(`/company/${companyId}/adsync/${id}`)

	browse = (companyId: id): CustomResponse<CompanyAdSyncBrowse[]> =>
		this.get(`/company/${companyId}/adsync`)

	create = (companyId: id, body: Body) =>
		this.post(`/company/${companyId}/adsync`, body)

	update = (companyId: id, id: id, body: Body) =>
		this.patch(`/company/${companyId}/adsync/${id}`, body)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/adsync/${id}`)

	sync = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/adsync/${id}/sync`)
}

export default AdSync
